import { IconButtonElement } from './IconButton.styles';

export default function IconButton({ children, disabled, id, label, onClick }: IconButtonProps) {

    return <IconButtonElement aria-label={label} disabled={disabled} id={id} onClick={onClick} >
        {children}
    </IconButtonElement>;

}